<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" :rules="filtersRules" ref="filters">
          <el-form-item prop="name">
            <el-input v-model="filters.name" placeholder="姓名" style="min-width: 120px"
              @keyup.enter.native="clickSearch('filters')"></el-input>
          </el-form-item>
          <el-form-item prop="mobile">
            <el-input v-model="filters.mobile"
              οninput="value=value.replace(/[^\d]/g,'');if(value.length > 11)value = value.slice(0, 11)" placeholder="手机号"
              style="min-width: 120px" @keyup.enter.native="clickSearch('filters')"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickSearch('filters')">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickAdd">增加</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('filters')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button v-show="isshowexcel" type="success" @click="listExcel" :loading="excelLoading">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="users" highlight-current-row v-loading="loading" border style="width: 100%">
        <el-table-column fixed label="序号" type="index" :index="indexMethod"></el-table-column>
        <el-table-column label="会员卡号" prop="card" min-width="80"></el-table-column>
        <el-table-column prop="mobile" label="手机号" width="100">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>{{ scope.row.mobile }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag>{{
                  scope.row.mobile.substring(0, 3) +
                  "****" +
                  scope.row.mobile.substring(7, 11)
                }}</el-tag>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名">
          <template slot-scope="scope">
            <el-popover trigger="hover" placement="top">
              <p>性别: {{ scope.row.sex == 0 ? "男" : scope.row.sex == 1 ? "女" : "未知" }}</p>
              <p>年龄: {{ scope.row.age }}</p>
              <div slot="reference" class="name-wrapper">
                <el-tag type="success" size="medium">{{ scope.row.name }}</el-tag>
              </div>
            </el-popover>
          </template>

        </el-table-column>
        <!-- <el-table-column prop="sex" label="性别" min-width="60" :formatter="formatSex"></el-table-column>
        <el-table-column prop="age" label="年龄" min-width="60"></el-table-column> -->
        <el-table-column prop="birth" label="出生日期" min-width="90"></el-table-column>
        <!-- <el-table-column prop="job" label="职业"> </el-table-column> -->
        <el-table-column prop="level" label="会员等级"></el-table-column>
        <el-table-column prop="points" label="系统积分"></el-table-column>
        <el-table-column prop="erppoints" label="ERP积分"></el-table-column>
        <el-table-column prop="totalpoints" label="剩余积分"> </el-table-column>
        <el-table-column prop="total" label="总积分"> </el-table-column>
        <el-table-column label="积分记录" fixed="right" min-width="160">
          <template slot-scope="scope">
            <el-button type="text" @click="showLogDialog(scope.$index, scope.row)">系统积分</el-button>
            <el-button type="text" @click="showERPDialog(scope.$index, scope.row)">ERP积分</el-button>
          </template>
        </el-table-column>
        <el-table-column label="积分兑换" fixed="right" min-width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="showRedDialog(scope.$index, scope.row)">兑换</el-button>
            <el-button type="text" @click="showRedLogDialog(scope.$index, scope.row)">兑换记录</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" min-width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="showEditDialog(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" @click="showAddDialog(scope.$index, scope.row)">添加积分</el-button>

            <!-- <el-button type="text" @click="showEditDialog(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" @click="showAddDialog(scope.$index, scope.row)">添加积分</el-button>
            <el-button type="text" @click="showLogDialog(scope.$index, scope.row)">积分记录</el-button>
            <el-button type="text" @click="showRedDialog(scope.$index, scope.row)">兑换</el-button>
            <el-button type="text" @click="showRedLogDialog(scope.$index, scope.row)">兑换记录</el-button>
            <el-button type="text" @click="showRedLogDialog(scope.$index, scope.row)">ERP订单记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>

      <!-- 添加积分 -->
      <el-dialog title="添加积分" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
          <el-form-item label="会员姓名" prop="name">
            <el-input v-model="addForm.name" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="卡号" prop="card">
            <el-input v-model="addForm.card" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="addForm.mobile" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="productname">
            <el-input v-model="addForm.productname"></el-input>
          </el-form-item>
          <el-form-item label="数量" prop="count">
            <el-input v-model="addForm.count" type="number"></el-input>
          </el-form-item>
          <el-form-item label="单价" prop="price">
            <el-input v-model="addForm.price"></el-input>
          </el-form-item>
          <el-form-item label="总金额" prop="memberpoints">
            <el-input v-model="addForm.memberpoints"></el-input>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="addForm.remark"></el-input>
          </el-form-item>
          <el-form-item label="红包使用" prop="packet">
            <el-tag v-show="isshowpacket">无可用红包啦</el-tag>
            <el-radio-group style="color:red" v-model="packet">
              <el-radio v-show="!isshowpacket" label="0" border>不使用红包
              </el-radio>
              <el-radio :label="item.id" :key="item.id" v-for="item in packetList" border>
                {{ item.coupons + '元红包 有效期:' + dateFormatTime(item.usestartdate) + '至' + dateFormatTime(item.useenddate)
                }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="优惠券" prop="cash">
            <el-tag v-show="isshowcash">无可用优惠券啦</el-tag>
            <el-radio-group style="color:red" v-model="cash">
              <el-radio v-show="!isshowcash" label="0" border>不使用优惠券
              </el-radio>
              <el-radio :label="item.id" :key="item.id" v-for="item in cashList" border>
                {{ '满' + item.morethan + '减' + item.cash + ' 有效期:' + dateFormatTime(item.usestartdate) + '至' +
                  dateFormatTime(item.useenddate)
                }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="购物积分" prop="point">
            <el-input v-model="addForm.point"></el-input>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm">
          <el-form-item label="会员姓名" prop="name">
            <el-input v-model="editForm.name"></el-input>
          </el-form-item>

          <el-form-item label="手机号码" prop="mobile">
            <el-input v-model="editForm.mobile"
              οninput="value=value.replace(/[^\d]/g,'');if(value.length > 11)value = value.slice(0, 11)"></el-input>
          </el-form-item>

          <el-form-item label="出生日期" prop="birth">
            <el-date-picker placeholder="出生日期" v-model="editForm.birth"></el-date-picker>
          </el-form-item>

          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="editForm.sex">
              <el-radio :label="0" v-model="editForm.sex">男</el-radio>
              <el-radio :label="1" v-model="editForm.sex">女</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="职业" prop="job">
            <el-input v-model="editForm.job"></el-input>
          </el-form-item>

          <!-- <el-form-item label="邮箱" prop="email">
            <el-input v-model="editForm.email"></el-input>
          </el-form-item> -->

          <el-row :gutter="10">
            <el-col :span="12">
              <el-form-item label="所属地区" prop="address">
                <el-cascader size="large" :options="editoptions" v-model="editselectedOptions"
                  @change="edithandleChange"></el-cascader>
              </el-form-item>
              <el-form-item prop="detail">
                <el-input placeholder="详细地址" v-model="detail"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-form-item label="地址" prop="address">
            <el-input v-model="editForm.address"></el-input>
          </el-form-item> -->
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
      <!-- 历史积分记录 -->
      <el-dialog title="系统积分记录" :visible.sync="logFormVisible" :close-on-click-modal="false">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
          <el-form :inline="true">
            <el-form-item>
              <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleLogSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="logExcel">导出</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <!--列表-->
        <el-table :data="logPoints" highlight-current-row v-loading="loading" border style="width: 100%">
          <el-table-column label="序号" type="index">
          </el-table-column>
          <el-table-column prop="card" label="会员卡号">
          </el-table-column>
          <el-table-column prop="name" label="会员姓名">
          </el-table-column>
          <el-table-column prop="shopName" label="购物中心" min-width="100"> </el-table-column>
          <el-table-column prop="productname" label="商品名称"> </el-table-column>
          <el-table-column prop="count" label="数量"> </el-table-column>
          <el-table-column prop="price" label="单价"> </el-table-column>
          <el-table-column prop="time" label="消费时间" min-width="100"> </el-table-column>
          <el-table-column prop="points" label="消费积分">
          </el-table-column>
          <el-table-column prop="remark" label="备注">
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="100">
            <template slot-scope="scope">
              <el-button type="text" v-show="scope.row.points > 0 && scope.row.flag == 0"
                @click="openError(scope.$index, scope.row)">录错
              </el-button>
              <el-button type="text" v-show="scope.row.points > 0 && scope.row.flag == 0"
                @click="openSalesReturn(scope.$index, scope.row)">退货
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next" @current-change="handlelogCurrentChange" :page-size="10"
            :total="totallog" style="float: right">
          </el-pagination>
        </el-col>
      </el-dialog>
      <!-- 积分兑换 -->
      <el-dialog title="积分兑换" :visible.sync="redFormVisible" :close-on-click-modal="false">
        <el-form :model="redForm" label-width="80px" :rules="redFormRules" ref="redForm">
          <el-form-item label="会员特权" prop="privile">
            <el-select v-model="redForm.privile" multiple placeholder="请选择">
              <el-option v-for="item in pointsList" :key="item" :label="item" :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="抵扣积分" prop="points">
            <el-input v-model="redForm.points"></el-input>
          </el-form-item>
          <el-form-item label="特权详情" prop="common">
            <el-input type="textarea" v-model="redForm.common"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="redFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="redSubmit" :loading="redLoading">提交</el-button>
        </div>
      </el-dialog>
      <!-- 兑换记录 -->
      <el-dialog title="兑换记录" :visible.sync="redlogFormVisible" :close-on-click-modal="false">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
          <el-form :inline="true" :model="sev" :rules="sevRules" ref="sev">
            <el-form-item prop="value2">
              <el-date-picker v-model="sev.value2" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleRedLogSearch('sev')">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="redLogExcel">导出</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <!--列表-->
        <el-table :data="redLog" highlight-current-row v-loading="loading" border style="width: 100%">
          <el-table-column label="序号" type="index"> </el-table-column>
          <el-table-column prop="card" label="会员卡号"> </el-table-column>
          <el-table-column prop="name" label="会员姓名"> </el-table-column>
          <el-table-column prop="points" label="抵扣积分">
          </el-table-column>
          <el-table-column prop="shopName" label="兑换中心" width="100">
          </el-table-column>
          <el-table-column prop="time" label="兑换时间" min-width="90"> </el-table-column>
          <el-table-column prop="privilege" label="所用特权" width="240"></el-table-column>
          <el-table-column prop="common" label="特权详情"> </el-table-column>
        </el-table>

        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next" @current-change="handleredCurrentChange" :page-size="10"
            :total="totalred" style="float: right">
          </el-pagination>
        </el-col>
      </el-dialog>
      <!-- ERP订单记录 -->
      <el-dialog title="ERP订单记录" :visible.sync="erplogFormVisible" :close-on-click-modal="false">
        <!--工具条-->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
          <el-form :inline="true">
            <el-form-item>
              <el-date-picker v-model="value3" type="daterange" range-separator="至" start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleErpSearch">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <!--列表-->
        <el-table :data="erpLog" highlight-current-row v-loading="loading" border style="width: 100%">
          <el-table-column label="序号" type="index" fixed></el-table-column>
          <el-table-column prop="cusno" label="门店编号" min-width="100"></el-table-column>
          <el-table-column prop="psno" label="销货单号" min-width="100"></el-table-column>
          <el-table-column prop="prdname" min-width="240" label="商品名称"> </el-table-column>
          <el-table-column prop="prdno" label="商品编号" min-width="110"> </el-table-column>
          <el-table-column prop="prdqty" label="数量" min-width="60"> </el-table-column>
          <el-table-column prop="prdprice" label="单价" min-width="60"> </el-table-column>
          <el-table-column prop="prddiscnt" label="折扣"> </el-table-column>
          <el-table-column prop="prdamt" label="金额" min-width="60"></el-table-column>
          <el-table-column prop="psdd" label="销货时间" min-width="90" fixed="right" :formatter="formatTime">
          </el-table-column>
        </el-table>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next" @current-change="handleErpCurrentChange" :page-size="10"
            :total="totalerp" style="float: right">
          </el-pagination>
        </el-col>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import API from "../../../api/frbasicapi/member";
import moment from 'moment';
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode,
} from "element-china-area-data";
import {
  isIntegerNotMust,
  validatePhone,
  validatetoFixedNew,
} from "../../../utils/validators";
export default {
  data() {
    return {
      indexshow: 0,
      indexrow: {},
      isshowexcel: true,
      detail: "",
      filters: {
        name: "",
        mobile: "",
        type: 0, //默认为0，当点击搜索触发的时候变为1
      },
      filtersRules: {
        mobile: [{ validator: validatePhone }],
      },
      loading: false,
      users: [],
      roles: [],
      roleIds: [],
      total: 0,
      page: 1,
      limit: 10,
      value1: "",
      value2: "",
      value3: "",
      excelLoading: false,

      editoptions: regionDataPlus,
      editselectedOptions: [],
      //编辑相关数据
      editFormVisible: false,
      editFormRules: {
        name: [{ required: true, message: "请输入会员姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone },
        ],
        birth: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        address: [
          { required: true, message: "请选择所属地区", trigger: "blur" },
        ],
      },
      editForm: {
        name: "",
        mobile: "",
        birth: "",
        sex: "0",
        job: "",
        email: "",
        address: "",
      },

      //新增积分相关数据

      //红包数据
      packet: "0",
      packetList: [],
      isshowpacket: false,

      //优惠券数据
      cash: "0",
      cashList: [],
      isshowcash: false,

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        // point: [
        //   { required: true, message: "请输入购物积分", trigger: "blur" },
        //   { validator: validatetoFixedNew },
        // ],
        productname: [
          { required: true, message: "请输入产品名称", trigger: "blur" },
        ],
        count: [{ required: true, message: "请输入数量", trigger: "blur" }],
        price: [
          { required: true, message: "请输入单价", trigger: "blur" },
          { validator: validatetoFixedNew },
        ],
        memberpoints: [
          { required: true, message: "请输入金额(积分)", trigger: "blur" },
          { validator: validatetoFixedNew },
        ],
      },
      addForm: {
        // id: "",
        // card: "",
        // name: "",
        // mobile: "",
        // point: "",
      },
      paramAddForm: {
        id: "",
        point: "",
      },

      //积分历史记录
      logFormVisible: false, //积分历史记录是否显示
      logForm: {},
      logPoints: [],
      totallog: 0,
      pagelog: 1,
      limitlog: 10,

      //积分兑换
      redFormVisible: false, //积分兑换是否显示
      redLoading: false,
      redFormRules: {
        points: [
          // { required: true, message: "请输入抵扣积分", trigger: "blur" },
          { validator: validatetoFixedNew },
        ],
        privile: [{ required: true, message: "请选择特权", trigger: "blur" }],
      },
      redForm: {
        points: 0,
        privile: [],
      },
      nowForm: {},
      pointsList: [],
      ordinary: [
        "会员消费积分",
        "会员生日礼物",
        "门店特权产品优先购",
        "买婚嫁喜服,婚嫁道具免费借用服务",
      ],
      vip: [
        "会员消费积分",
        "会员生日礼物",
        "会员免费上门试铺服务",
        "会员免费上分除螨服务",
        "买婚嫁喜服,婚嫁道具免费借用服务",
        "会员生日当日消费2倍积分",
        "会员购物折上98折特权",
      ],
      svip: [
        "会员消费积分",
        "会员生日礼物",
        "会员免费上门试铺服务",
        "会员免费上分除螨服务",
        "买婚嫁喜服,婚嫁道具免费借用服务",
        "会员生日当日消费5倍积分",
        "会员购物折上95折特权",
        "购物包邮",
      ],
      redlogForm: {},
      redlogFormVisible: false,
      redLog: [],
      totalred: 0,
      pagered: 1,
      limitred: 10,

      sevRules: {
        value2: [{ required: true, message: "请选择时间", trigger: "blur" }],
      },
      sev: {},

      //Erp
      erplogForm: {},
      erplogFormVisible: false,
      erpLog: [],
      totalerp: 0,
      pageerp: 1,
      limiterp: 10,
    };
  },
  methods: {
    //序号
    indexMethod(index) {
      return (index + 1) + (this.page - 1) * (this.limit)
    },
    formatTime(row, column) {
      let date = row[column.property];
      if (date === undefined) {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },

    dateFormatTime(date) {
      var time = new Date(date);
      var y = time.getFullYear()
      var m = time.getMonth() + 1
      var d = time.getDate()
      var h = time.getHours()
      var mm = time.getMinutes()
      var s = time.getSeconds()
      //return y + '-' + this.timeAdd0(m) + '-' + this.timeAdd0(d) + ' ' + this.timeAdd0(h) + ':' + this.timeAdd0(mm) + ':' + this.timeAdd0(s)
      return y + '-' + this.timeAdd0(m) + '-' + this.timeAdd0(d)

    },
    timeAdd0(str) {
      if (str < 10) {
        str = '0' + str
      }
      return str
    },
    edithandleChange(value) {
      var province = "";
      var city = "";
      var country = "";
      if (value != null && value != "") {
        province = CodeToText[value[0]];
        if (value[1] != null && value[1] != "") {
          city = CodeToText[value[1]];
        }
        if (value[2] != null && value[2] != "") {
          country = CodeToText[value[2]];
        }
        this.editForm.address = province + "/" + city + "/" + country;
      }
    },

    //性别显示转换
    formatSex: function (row, column) {
      return row.sex == 0 ? "男" : row.sex == 1 ? "女" : "未知";
    },
    formatmobile: function (row, column) {
      return row.mobile.substring(0, 3) + "****" + row.mobile.substring(7, 11);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    //点击按钮查询
    clickSearch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.total = 0;
          this.page = 1;
          this.filters.type = 1;
          this.search();
        }
      });
    },
    clickAdd() {
      //console.log("跳转哪呢");
      this.$router.push("/sys/frbasicmember/add");
    },
    //会员列表导出
    listExcel() {
      // 调用api接口
      let that = this;
      API.listExcel().then((res) => {
        that.excelLoading = true;
        if (res) {
          const content = res;
          //console.log(res.headers['filename']);
          const blob = new Blob([content]);
          if ("download" in document.createElement("a")) {
            const link = document.createElement("a");
            // 文件名
            link.download = "会员信息列表Excel.xlsx";
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
            that.excelLoading = false;
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
        }
      });
    },
    //积分记录导出
    logExcel() {
      // 调用api接口
      let that = this;
      var da = null;
      if (this.value1 != "" && this.value1 != null) {
        da =
          this.dateFormat(this.value1.toString().split(",")[0]) +
          "," +
          this.dateFormat(this.value1.toString().split(",")[1]);
      }
      let params = {
        memberId: this.logForm.id,
        value: da,
      };

      API.logExcel(params).then((res) => {
        that.excelLoading = true;
        if (res) {
          const content = res;
          //console.log(res.headers['filename']);
          const blob = new Blob([content]);
          if ("download" in document.createElement("a")) {
            const link = document.createElement("a");
            // 文件名
            link.download = "积分历史记录Excel.xlsx";
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
            that.excelLoading = false;
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
        }
      });
    },
    //兑换记录导出
    redLogExcel() {
      // 调用api接口
      let that = this;
      var da = null;
      if (this.sev.value2 != "" && this.sev.value2 != null) {
        da =
          this.dateFormat(this.sev.value2.toString().split(",")[0]) +
          "," +
          this.dateFormat(this.sev.value2.toString().split(",")[1]);
      }

      let params = {
        memberId: this.redlogForm.id,
        value: da,
      };

      API.redLogExcel(params).then((res) => {
        that.excelLoading = true;
        if (res) {
          const content = res;
          //console.log(res.headers['filename']);
          const blob = new Blob([content]);
          if ("download" in document.createElement("a")) {
            const link = document.createElement("a");
            // 文件名
            link.download = "积分兑换记录Excel.xlsx";
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            document.body.appendChild(link);
            link.click();
            URL.revokeObjectURL(link.href);
            document.body.removeChild(link);
            that.excelLoading = false;
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
        }
      });
    },
    //获取用户列表
    search: function () {
      let that = this;
      let params = {
        pageNum: that.page,
        pageSize: 10,
        name: that.filters.name,
        flag: that.filters.type,
        mobile: that.filters.mobile,
      };

      that.loading = true;
      API.getPageList(params)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.data.totalSize) {
              that.total = result.data.totalSize;
              that.users = result.data.content;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          //console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    //添加积分
    showAddDialog: function (index, row) {

      this.addFormVisible = true;
      this.addForm = Object.assign({}, row);
      // this.addForm.packet="0";

      //红包优惠券数据展示
      let params = { memberId: this.addForm.id };

      let that = this;
      API.getRedPacket(params)
        .then(
          function (result) {
            if (0 === result.code) {
              //红包信息
              that.packetList = result.data.coupons;
              console.log(result.data.coupons.length)
              if (result.data.coupons.length == 0) {
                that.isshowpacket = true;
              } else {
                that.isshowpacket = false;
              }
              //优惠券信息
              that.cashList = result.data.redcashes;
              if (result.data.redcashes.length == 0) {
                that.isshowcash = true;
              } else {
                that.isshowcash = false;
              }
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
      //console.log(this.packetList);


    },
    showEditDialog: function (index, row) {
      let that = this;
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.editselectedOptions = [
        TextToCode[row.address.split("/")[0]].code,
        TextToCode[row.address.split("/")[0]][row.address.split("/")[1]].code,
        TextToCode[row.address.split("/")[0]][row.address.split("/")[1]][
          row.address.split("/")[2]
        ].code,
      ];
      this.detail = row.address.split("/")[3];
    },

    //积分历史记录
    showLogDialog: function (index, row) {
      this.indexshow = index;
      this.indexrow = row;
      this.value1 = "";
      let that = this;
      this.logForm = Object.assign({}, row);
      that.pagelog = 1;
      let params = {
        memberId: this.logForm.id,
        pageNum: that.pagelog,
        pageSize: 10,
      };
      this.searchLog(params);
    },
    //积分历史记录  分页跳转
    handlelogCurrentChange(val) {
      this.pagelog = val;
      var da = null;
      if (this.value1 != "" && this.value1 != null) {
        da =
          this.dateFormat(this.value1.toString().split(",")[0]) +
          "," +
          this.dateFormat(this.value1.toString().split(",")[1]);
      }

      let params = {
        pageNum: this.pagelog,
        pageSize: 10,
        memberId: this.logForm.id,
        value: da,
      };
      this.searchLog(params);
    },
    //积分历史记录 点击搜索
    handleLogSearch() {
      this.pagelog = 1;
      var da = null;
      if (this.value1 != "" && this.value1 != null) {
        da =
          this.dateFormat(this.value1.toString().split(",")[0]) +
          "," +
          this.dateFormat(this.value1.toString().split(",")[1]);
      }
      let params = {
        pageNum: this.pagelog,
        pageSize: 10,
        memberId: this.logForm.id,
        value: da,
      };
      this.searchLog(params);
    },
    //积分历史记录 分页
    searchLog(params) {
      let that = this;
      API.pointsLogPage(params)
        .then(
          function (result) {
            if (0 === result.code) {
              that.logFormVisible = true;
              that.totallog = result.data.totalSize;
              that.logPoints = result.data.content;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    //兑换
    showRedDialog: function (index, row) {
      this.redForm = {
        points: 0,
        privile: [],
      };
      let that = this;
      this.redFormVisible = true;
      this.nowForm = Object.assign({}, row);
      this.redForm.memberid = this.nowForm.id;
      if (this.nowForm.level == "普通会员") {
        this.pointsList = this.ordinary;
      }
      if (this.nowForm.level == "vip会员") {
        this.pointsList = this.vip;
      }
      if (this.nowForm.level == "svip会员") {
        this.pointsList = this.svip;
      }
    },

    //兑换记录
    showRedLogDialog: function (index, row) {
      let that = this;
      that.pagered = 1;
      this.redlogForm = Object.assign({}, row);
      let params = {
        memberId: this.redlogForm.id,
        pageNum: that.pagered,
        pageSize: 10,
      };
      this.searchRed(params);
    },
    //兑换记录 点击搜索
    handleRedLogSearch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let that = this;
          that.pagered = 1;

          var da = null;
          if (this.sev.value2 != "" && this.sev.value2 != null) {
            da =
              this.dateFormat(this.sev.value2.toString().split(",")[0]) +
              "," +
              this.dateFormat(this.sev.value2.toString().split(",")[1]);
          }

          let params = {
            memberId: this.redlogForm.id,
            value: da,
            pageNum: that.pagered,
            pageSize: 10,
          };

          this.searchRed(params);
        }
      });
    },
    //兑换记录 分页跳转
    handleredCurrentChange(val) {
      this.pagelog = val;
      var da = null;
      var da = null;
      if (this.sev.value2 != "" && this.sev.value2 != null) {
        da =
          this.dateFormat(this.sev.value2.toString().split(",")[0]) +
          "," +
          this.dateFormat(this.sev.value2.toString().split(",")[1]);
      }

      let params = {
        pageNum: this.pagelog,
        pageSize: 10,
        memberId: this.redlogForm.id,
        value: da,
      };
      this.searchRed(params);
    },
    //兑换记录 分页
    searchRed(params) {
      let that = this;
      API.redeemLogPage(params)
        .then(
          function (result) {
            if (0 === result.code) {
              that.redlogFormVisible = true;
              that.totalred = result.data.totalSize;
              that.redLog = result.data.content;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    //ERP订单
    showERPDialog: function (index, row) {
      this.pageerp = 1
      this.erplogForm = Object.assign({}, row);
      let params = {
        mobile: this.erplogForm.mobile,
        pageNum: this.pageerp,
        pageSize: 10,
      }
      this.searchErp(params)
    },
    //ERP订单 点击搜索
    handleErpSearch() {
      this.pageerp = 1
      var da = null
      if (this.value3 != "" && this.value3 != null) {
        da =
          this.dateFormat(this.value3.toString().split(",")[0]) +
          "," +
          this.dateFormat(this.value3.toString().split(",")[1]);
      }
      let params = {
        pageNum: this.pageerp,
        pageSize: 10,
        mobile: this.erplogForm.mobile,
        value: da
      };
      this.searchErp(params)
    },
    //兑换记录 分页跳转
    handleErpCurrentChange(val) {
      this.pageerp = val;
      var da = null;
      if (this.value3 != "" && this.value3 != null) {
        da =
          this.dateFormat(this.value3.toString().split(",")[0]) +
          "," +
          this.dateFormat(this.value3.toString().split(",")[1]);
      }
      let params = {
        mobile: this.erplogForm.mobile,
        pageNum: this.pageerp,
        pageSize: 10,
        value: da
      };
      this.searchErp(params);
    },
    //兑换记录 分页
    searchErp(params) {
      let that = this;
      API.getErpListPage(params)
        .then(
          function (result) {
            if (0 === result.code) {
              that.erplogFormVisible = true;
              that.totalerp = result.data.totalSize;
              that.erpLog = result.data.content;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },


    dateFormat(dateData) {
      var date = new Date(dateData);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + m + "-" + d;
      return time;
    },
    addSubmitByMsg: function () {
      let that = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, this.addForm);
          this.paramAddForm.id = params.id;
          this.paramAddForm.point = params.memberpoints;
          this.paramAddForm.productname = params.productname;
          this.paramAddForm.count = params.count;
          this.paramAddForm.price = params.price;
          this.paramAddForm.remark = params.remark;
          this.paramAddForm.packet = this.packet;
          this.paramAddForm.cash = this.cash;
          API.addPoints(this.paramAddForm).then(function (result) {
            //console.log(result.code);
            if (0 === result.code) {
              that.loading = false;
              that.$message;
              that.$message.success({
                showClose: true,
                message: "新增成功",
                duration: 2000,
              });
              that.$refs["addForm"].resetFields();
              that.addFormVisible = false;
              that.packet = "0";
              that.search();

            } else {
              that.$message.error({
                showClose: true,
                message: result.msg || "新增失败",
                duration: 2000,
              });
            }
          });
        }
      });
    },
    addSubmit: function () {
      if (this.packet > 0 && this.cash > 0) {
        this.$message.error({
          showClose: true,
          message: "请注意,红包和优惠券每次只能使用一种哦！",
          duration: 2000,
        });
        return;
      }
      if (parseInt(this.packet) > 0 || parseInt(this.cash) > 0) {
        let confirmText = '您使用的红包或优惠券将抵扣对应的金额，确认添加？'
        this.$confirm(confirmText, '提示', {
          type: 'warning'
        }).then(() => {
          this.addSubmitByMsg();
        })
      } else {
        this.addSubmitByMsg();
      }

    },
    editSubmit: function () {
      let that = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          that.loading = true;
          let params = Object.assign({}, that.editForm);

          var start = params.address.length - 1; //相差长度为1
          var char = params.address.substr(start, params.address.length); //结尾

          if (char == "/") {
            params.address = params.address + this.detail;
          } else {
            params.address = params.address + "/" + this.detail;
          }

          // console.log(params);
          API.updateMember(params).then(function (result) {
            if (0 === result.code) {
              that.loading = false;
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 2000,
              });
              that.$refs["editForm"].resetFields();
              that.editFormVisible = false;
              that.search();
            } else {
              that.$message.error({
                showClose: true,
                message: result.msg,
                duration: 2000,
              });
            }
          });
        }
      });
    },
    resetForm(formName) {
      // this[formName] = {};

      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },
    redSubmit: function () {
      let that = this;
      this.$refs.redForm.validate((valid) => {
        if (valid) {
          if (
            parseFloat(this.nowForm.totalpoints) <
            parseFloat(this.redForm.points)
          ) {
            that.$message.error({
              showClose: true,
              message: "兑换积分不得高于总积分",
              duration: 2000,
            });
          } else {
            that.loading = true;
            API.addRedeem(this.redForm).then(function (result) {
              // console.log(result.code);
              if (0 === result.code) {
                that.loading = false;
                that.$message;
                that.$message.success({
                  showClose: true,
                  message: "操作成功",
                  duration: 2000,
                });
                that.$refs["redForm"].resetFields();
                that.redFormVisible = false;
                that.search();
              } else {
                that.$message.error({
                  showClose: true,
                  message: result.msg || "操作失败",
                  duration: 2000,
                });
              }
            });
          }
        }
      });
    },

    isShow: function () {
      this.isshowexcel = false;
      let that = this;
      API.getShowExcel().then(function (result) {
        if (0 === result.code) {
          if (result.data === 1) {
            that.isshowexcel = false;
          } else {
            that.isshowexcel = true;
          }

        } else {
          that.$message.error({
            showClose: true,
            message: result.msg || "操作失败",
            duration: 2000,
          });
        }
      });
    },

    //录错
    openError: function (index, row) {
      this.$prompt('请输入录错备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '备注不能为空'
      }).then(({ value }) => {
        let param = Object.assign({}, row);
        let form = {
          id: param.memberid,
          point: param.points,
          shopid: param.shopid,
          productname: param.productname,
          count: param.count,
          price: param.price,
          pointid: param.id,
          flag: 1,
          remark: "录错备注:" + value
        };
        this.$confirm("录错冲正后，请重新录入正确信息", "提示", { type: "warning" })
          .then(() => {
            this.addfalseLog(form);
          })
          .catch(() => { });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },
    //退货
    openSalesReturn: function (index, row) {
      this.$prompt('请输入退货备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '备注不能为空'
      }).then(({ value }) => {
        let param = Object.assign({}, row);
        let form = {
          id: param.memberid,
          point: param.points,
          shopid: param.shopid,
          productname: param.productname,
          count: param.count,
          price: param.price,
          pointid: param.id,
          flag: 2,
          remark: "退货备注:" + value
        };
        this.addfalseLog(form);
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });
      });
    },

    //录错，退货接口请求
    addfalseLog: function (form) {
      let that = this;
      API.addFalsePoints(form).then(function (result) {
        console.log(result);
        //that.showLogDialog(that.indexshow, that.indexrow);
        if (0 === result.code) {
          that.showLogDialog(that.indexshow, that.indexrow);
        } else {
          that.$message.error({
            showClose: true,
            message: result.message || "操作失败",
            duration: 5000,
          });
        }
        // if (0 === result.code) {
        //   that.loading = false;
        //   that.$message;
        //   that.$message.success({
        //     showClose: true,
        //     message: "操作成功",
        //     duration: 2000,
        //   });
        //   that.$refs["redForm"].resetFields();
        //   that.redFormVisible = false;
        //   that.search();
        // } else {
        //   that.$message.error({
        //     showClose: true,
        //     message: result.msg || "操作失败",
        //     duration: 2000,
        //   });
        // }
      });
    }
  },
  mounted() {
    this.handleSearch();
    this.isShow();
  },
};
</script>
<style scoped>
::v-deep .el-radio {
  display: block;
  margin: 10px 0;
}
</style>
<style scoped>
::v-deep .el-radio__label {
  color: red;
  margin-right: 10px
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
  color: red !important;
}

::v-deep .el-radio__input.is-checked .el-radio__inner {
  background: red !important;
  border-color: red !important;
}
</style>
